module.exports = {
    tag: 'masterwork',
    quality: 0.6,
    learning: 2,
    damageMod: 0.15,
    speed: 0.3
};